import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/gatsby-test/gatsby-test/src/components/DefaultLayout.js";
import { QnA, Q, A } from "@/components/QnA";
import FAQList from "@/components/FAQList";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`FAQ`}</h1>
    <QnA mdxType="QnA">
	<Q mdxType="Q">
		Who is behind RoutED?
	</Q>
	<A mdxType="A">
		Code for San Francisco is a part of the Code for America Brigade Network, a volunteer civic tech organization that leverages 21st-century technology to solve problems and to make life easier for civil servants working in local government. The Routed team is a dedicated group of volunteers composed of project managers, software engineers, data analysts, full-stack developers, and designers, with experience in transportation, patient health care records, hospitality, government services, and logistics.
	</A>
    </QnA>
    <QnA mdxType="QnA">
	<Q mdxType="Q">
		Who is RoutED available to today?
	</Q>
	<A mdxType="A">
		People!
	</A>
    </QnA>
    <QnA mdxType="QnA">
	<Q mdxType="Q">
		What is RoutED? What problem does it aim to solve?
	</Q>
	<A mdxType="A">
		Problems!
	</A>
    </QnA>
    <QnA mdxType="QnA">
	<Q mdxType="Q">
		Does RoutED replace [CADDIE, RediNet, etc.]?
	</Q>
	<A mdxType="A">
		Sure, why not!
	</A>
    </QnA>
    <QnA mdxType="QnA">
	<Q mdxType="Q">
		Does a digital ringdown replace the need for radio?
	</Q>
	<A mdxType="A">
		At this stage, the digital ringdown within RoutED fully replaces the need for radio communication with non-critical Code 2 patients only.
	</A>
    </QnA>
    <QnA mdxType="QnA">
	<Q mdxType="Q">
		Does the RoutED platform incorporate all hospitals? All ambulance networks?
	</Q>
	<A mdxType="A">
		Nope!
	</A>
    </QnA>
    <QnA mdxType="QnA">
	<Q mdxType="Q">
		How is patient information protected?
	</Q>
	<A mdxType="A">
		Well!
	</A>
    </QnA>
    <FAQList mdxType="FAQList" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      